import { State } from "infrontjs";

import template from './TokenTemplate.html';
import { _lcs } from "../../i18n";

/**
 * TokenState — landing point of every action link the core-api mails out
 * (#/token/{token}).
 *
 * Looks the token up (GET /auth/token/{token}) and routes by its `action` to the
 * screen that redeems it; this state itself never consumes a token. Today that
 * is resetPassword → PasswordResetState. A new action adds a case to
 * routeForAction() (and its redeem case in the core-api's TokenPutRequest).
 *
 * Deliberately NOT an AuthState, like the client-admin's: the link may well be
 * opened in a browser that is still signed in — what happens then is up to the
 * target state.
 */
export class TokenState extends State
{
    static ROUTE = '/token/:token';
    static ID = 'auth-token';

    async enter()
    {
        const host = this.app.container.querySelector( "#main-wrapper" )
            || this.app.view.pageContent
            || document.body;
        this.app.view.render( host, template );
        this.host = host;

        const back = host.querySelector( '[data-id="btn-back-to-login"]' );
        this.addEventListener( back, "click", ( e ) =>
        {
            e.preventDefault();
            this.app.router.redirect( "/login" );
        } );

        const tokenHash = this.getParam( 'token' );
        if ( !tokenHash )
        {
            this._showError( _lcs( "Dieser Link ist unvollständig." ) );
            return;
        }

        try
        {
            const { result } = await this.app.api.get( '/auth/token/' + encodeURIComponent( tokenHash ) );
            const token = ( result && +result.status === 200 ) ? result.data : null;
            const route = token ? this.routeForAction( token ) : null;
            if ( !route )
            {
                throw new Error( "Unsupported token action: " + ( token ? token.action : "-" ) );
            }
            this.app.router.redirect( route );
        }
        catch ( err )
        {
            console.error( err );
            this._showError( this._errorMessageForStatus( +err?.status ) );
        }
    }

    /** The route that redeems a token of this action — null if this app has none. */
    routeForAction( token )
    {
        switch ( token.action )
        {
            // PasswordResetState.ROUTE with the token filled in.
            case "resetPassword":
                return "/password-reset/" + encodeURIComponent( token.token );

            default:
                return null;
        }
    }

    _errorMessageForStatus( status )
    {
        switch ( status )
        {
            case 404: return _lcs( "Dieser Link wurde bereits verwendet oder ist nicht mehr gültig." );
            case 410: return _lcs( "Dieser Link ist abgelaufen. Bitte fordere einen neuen an." );
            default:  return _lcs( "Dieser Link kann hier nicht verwendet werden." );
        }
    }

    _showError( message )
    {
        const q = ( id ) => this.host.querySelector( '[data-id="' + id + '"]' );

        q( "token-title" ).textContent = _lcs( "Link ungültig" );
        q( "token-text" ).hidden = true;
        q( "token-status" ).hidden = false;
        q( "btn-back-to-login" ).hidden = false;

        const error = q( "token-error" );
        error.textContent = message;
        error.hidden = false;
    }

    async exit()
    {
    }
}
